export const socialStars = [
  {
    id: 1,
    name: "Marcus Johnson",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    platformColor: "#FF0000",
    specialty: "Career Coach",
    followers: "2.4M",
    engagement: "8.2%",
    bio: "Helping professionals land their dream jobs with proven strategies and resume tips.",
    avatar: "https://public.readdy.ai/ai/img_res/0c016ac7e7dbcaf25a2308d3ed982465.jpg",
    featured: true,
  },
  {
    id: 2,
    name: "Sophia Chen",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    platformColor: "#010101",
    specialty: "Finance Guru",
    followers: "3.8M",
    engagement: "12.5%",
    bio: "Making personal finance simple and accessible for everyone.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20female%20finance%20expert%20portrait%20confident%20clean%20studio%20background%20headshot&width=300&height=300&seq=inf2&orientation=squarish",
    featured: false,
  },
  {
    id: 3,
    name: "David Williams",
    platform: "Facebook",
    platformIcon: "ri-facebook-circle-line",
    platformColor: "#1877F2",
    specialty: "Business Mentor",
    followers: "1.2M",
    engagement: "6.8%",
    bio: "Entrepreneur and business mentor sharing insights on scaling startups.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20mentor%20portrait%20mature%20confident%20clean%20background%20headshot&width=300&height=300&seq=inf3&orientation=squarish",
    featured: false,
  },
  {
    id: 4,
    name: "Aisha Patel",
    platform: "Twitter",
    platformIcon: "ri-twitter-x-line",
    platformColor: "#14171A",
    specialty: "Tech Recruiter",
    followers: "890K",
    engagement: "9.1%",
    bio: "Top tech recruiter sharing insider tips on landing jobs at FAANG companies.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20south%20asian%20female%20tech%20recruiter%20portrait%20confident%20clean%20studio%20headshot&width=300&height=300&seq=inf4&orientation=squarish",
    featured: false,
  },
  {
    id: 5,
    name: "James Rivera",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    platformColor: "#FF0000",
    specialty: "Investment Expert",
    followers: "1.7M",
    engagement: "7.4%",
    bio: "Stock market analyst and investment strategist with 15 years of experience.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20investment%20expert%20portrait%20confident%20suit%20clean%20background%20studio%20headshot&width=300&height=300&seq=inf5&orientation=squarish",
    featured: false,
  },
  {
    id: 6,
    name: "Lily Thompson",
    platform: "TikTok",
    platformIcon: "ri-tiktok-line",
    platformColor: "#010101",
    specialty: "HR & Hiring Tips",
    followers: "5.1M",
    engagement: "14.3%",
    bio: "Viral HR expert revealing what recruiters really look for in candidates.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20HR%20expert%20portrait%20energetic%20smile%20clean%20studio%20background%20headshot&width=300&height=300&seq=inf6&orientation=squarish",
    featured: false,
  },
  {
    id: 7,
    name: "Kevin Park",
    platform: "Facebook",
    platformIcon: "ri-facebook-circle-line",
    platformColor: "#1877F2",
    specialty: "Dropship King",
    followers: "980K",
    engagement: "5.9%",
    bio: "Built a $2M dropshipping empire from scratch. Sharing every secret.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20asian%20male%20entrepreneur%20dropshipping%20expert%20portrait%20confident%20clean%20studio%20headshot&width=300&height=300&seq=inf7&orientation=squarish",
    featured: false,
  },
  {
    id: 8,
    name: "Natasha Brown",
    platform: "YouTube",
    platformIcon: "ri-youtube-line",
    platformColor: "#FF0000",
    specialty: "Lifestyle & Jobs",
    followers: "4.2M",
    engagement: "10.8%",
    bio: "Work-life balance advocate helping people find fulfilling careers they love.",
    avatar: "https://readdy.ai/api/search-image?query=professional%20black%20female%20lifestyle%20career%20influencer%20portrait%20warm%20smile%20clean%20studio%20headshot&width=300&height=300&seq=inf8&orientation=squarish",
    featured: false,
  },
];
